// extracted by mini-css-extract-plugin
export var body = "Post-module--body--bd841";
export var container = "Post-module--container--4e625";
export var copy = "Post-module--copy--dd945";
export var credit = "Post-module--credit--e4638";
export var credits = "Post-module--credits--002c6";
export var heroImage = "Post-module--hero-image--e5016";
export var heroPortrait = "Post-module--hero-portrait--c02fe";
export var postsNav = "Post-module--posts-nav--c5e52";